module.exports = "https://tutorchat.chegg.com/static/media/ic-star-active.3c6f5004.svg";